<!--结尾词-->
<template>
  <div class="background">
    <el-row>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <div style="color: #ffffff;text-shadow: 2px 2px 14px #000000;">
          <div>
            <div style="padding-top: 350px;padding-bottom: 20px;font-size: 50px">我们渴望讨论您的需求</div>
          </div>
          <div>
            <div style="padding-bottom: 10px;font-size: 20px">我们是2022年成立的全新团队,致力于开发各种好用又简单的工具应用.</div>
          </div>
          <div>
            <div style="padding-bottom: 10px;font-size: 20px">良好的编程习惯和高效的团队合作是我们对自己的基本要求.</div>
          </div>
          <div>
            <div style="padding-bottom: 10px;font-size: 20px">如果您有好的想法，欢迎与我们讨论,我们只是想让您的生活更简单.</div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "MyEpilogue"
}
</script>

<style scoped>

.background {
  width: 100%;
  height: 1080px;
  background: url("./town.jpeg");

  /* 背景图垂直、水平均居中 */
  background-position: center center;

  /* 背景图不平铺 */
  background-repeat: no-repeat;

  /* 当内容高度大于图片高度时，背景图像的位置相对于viewport固定 */
  /*background-attachment: fixed;*/

  /* 让背景图基于容器大小伸缩 */
  background-size: cover;
  text-align: center;

  color: #ffffff;
}

</style>
